const settings = {
  container: 'CrossSellContainer',
  template: 'TemplateCrossSellSlider',
  slider: 'CrossSellSlider'
}

const container = document.getElementById(settings.container);

const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function renderSliderElements() {
  const template = document.getElementById(settings.template);
  if (!template) return;

  // Render slider to main container
  container.innerHTML = template.textContent
}

function initSliderEvents() {
  const slider = document.getElementById(settings.slider);
  const options = {
    adaptiveHeight: true,
    groupCells: true,
    cellAlign: 'left'
  }

  if(!slider || slider.children.length <= 1) return

  let flkty = new Flickity(slider, options);
  document.addEventListener('drawerOpen', async e => {
    await timeout(600);
    flkty.resize();
  });
}

function init() {
  if (!container) return;
  renderSliderElements();
  initSliderEvents();
}

document.addEventListener('DOMContentLoaded', init, false);